'use client'

import { useCallback, useEffect, useRef, useState } from 'react'
type LoadingProgressProps = {
  isStart: boolean
  time: number
}
const LoadingProgress = ({ isStart, time }: LoadingProgressProps) => {
  const [progress, setProgress] = useState<number>(0)
  const loadingProcessInterval = useRef<NodeJS.Timeout | null>(null)

  const startLoadingProgress = useCallback(() => {
    if (loadingProcessInterval.current) {
      clearInterval(loadingProcessInterval.current)
    }
    setProgress(0)
    const interval = setInterval(
      () => {
        setProgress((prevProgress) => {
          if (prevProgress >= 99) {
            clearInterval(interval)
            return prevProgress
          }
          return prevProgress + 1
        })
      },
      (time * 1000) / 100
    )
    loadingProcessInterval.current = interval
  }, [time])

  const stopLoadingProgress = useCallback(() => {
    if (loadingProcessInterval.current) {
      clearInterval(loadingProcessInterval.current)
    }
  }, [])

  useEffect(() => {
    if (isStart) {
      startLoadingProgress()
    } else {
      stopLoadingProgress()
    }
  }, [isStart, startLoadingProgress, stopLoadingProgress])
  return <div>{progress}%</div>
}

export default LoadingProgress
